import { Box, Skeleton, styled, Typography, useTheme } from "@mui/material";
import { memo, useEffect, useState } from "react";
import shortid from "shortid";
import { apiGetLatestAccounting } from "../../api/dashboardApi";
import { formatIndex, formatPrice } from "../../helpers/dataFormat";
import { BoxUpper } from "../Shared/BoxUpper";
import { BoxBodyContainer, PriceComponent, RawBox, TagSection } from "../Shared/Dashboard/styled";
import {
  openAccountingDrawer,
  openFactorDrawer,
  openRemittanceDrawer,
  openTransactionDrawer,
  openTransferDrawer,
} from "../../helpers/DrawerActions";
import { useAppDispatch, useAppSelector } from "store/store";
import RefreshIcon from "assets/icons/RefreshIcon";

const StyledBoxBodyContainer = styled(BoxBodyContainer)({
  flexDirection: "column",
  height: "350px",
  overflowY: "scroll",
});

const Documents = ({ title }: { title?: string }) => {
  const dispatch = useAppDispatch();
  const latestAccountings = useAppSelector(
    (x) => x.dashboardReducer.latestAccountings
  ) as AccountingDataType[];
  const token = useAppSelector((x) => x.businessReducer.business?.token);

  // useEffect(() => {
  //   if (token) dispatch(apiGetLatestAccounting(token));
  // }, [token]);
  const onClick = () => {
    if (token) dispatch(apiGetLatestAccounting(token, changeLoading));
  }
  const [isLoading, setLoading] = useState(false)
  const changeLoading = () => {
    setLoading(state => !state)
  }
  return latestAccountings ? (
    <RawBox>
      <BoxUpper title={`${title} (${latestAccountings.length ?? ""})`} />
      <StyledBoxBodyContainer>
        {latestAccountings.map((item, key) => (
          <DocumentItem
            key={shortid.generate()}
            itemKey={key}
            accounting={item}
            count={latestAccountings.length ?? ""}
          />
        ))}
      </StyledBoxBodyContainer>
    </RawBox>
  ) : <RawBox>
    <BoxUpper title={`${title} (${0})`} />
    <Box
      onClick={() => {
        onClick()
      }}
      sx={{
        position: 'relative',
        width: '100%', // Set your desired width
        height: 350, // Set your desired height
        display: 'flex',
        justifyContent: 'center',
        padding: "24px 15px",
        cursor: 'pointer',
        alignItems: 'center',
        // border: '1px solid #ccc', // Optional: for visual reference
      }}
    >
      <Skeleton variant="rectangular" width={"100%"} height={"100%"} />
      <Typography
        variant="h6"
        sx={{
          position: 'absolute',
          color: '#747575', // Change color based on your skeleton background
        }}
      >
        نمایش اطلاعات
      </Typography>
      <div className={`absolute bottom-[35%] ${isLoading ? "animate-spin" : ""}`}>
        <RefreshIcon scale={0.8} />
      </div>

    </Box>
  </RawBox>;
};

export default memo(Documents);

const backgroundImage =
  "data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23AEAEAEFF' strokeWidth='3' stroke-dasharray='7%2c 9' stroke-dashoffset='31' stroke-linecap='square'/%3e%3c/svg%3e";
const DocumentContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  borderBottom: `solid 2px ${theme.palette.disabled.light}`,
  height: "130px",
  justifyContent: "space-evenly",
}));

const DocumentRowItem = styled("div")(({ theme }) => ({
  justifyContent: "space-between",
  display: "flex",
}));

const DashedButton = styled("div")(({ theme }) => ({
  width: "80px",
  height: "30px",
  backgroundColor: "white",
  fontSize: "11px",
  backgroundImage: `url("${backgroundImage}")`,
  backgroundSize: "100% 100%",
  borderRadius: "3px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: theme.palette.disabled.contrastText,
}));

const DocumentItem = ({
  accounting,
  itemKey,
}: {
  accounting: AccountingDataType;
  itemKey: number;
  count?: number;
}) => {
  const dispatch = useAppDispatch();
  const theme = useTheme();

  return (
    <DocumentContainer>
      <Typography color={theme.palette.disabled.contrastText} variant="body2">
        {accounting.date}
      </Typography>
      <DocumentRowItem>
        <Typography
          style={{ cursor: "pointer" }}
          onClick={() => {
            if (accounting && accounting.type && accounting.type_id) {
              if (accounting.type === "factor") {
                openFactorDrawer(dispatch, accounting);
              } else if (accounting.type === "transaction") {
                openTransactionDrawer(dispatch, accounting);
              } else if (accounting.type === "transfer") {
                openTransferDrawer(dispatch, accounting);
              } else if (accounting.type === "bill") {
                openRemittanceDrawer(dispatch, accounting);
              }
            } else {
              openAccountingDrawer(dispatch, accounting);
            }
          }}
          color="#000"
          variant="body2"
        >
          {`${formatIndex(itemKey, 3)} - ${accounting.description}`}
        </Typography>
        {accounting.status === "draft" && <DashedButton>پیش نویس</DashedButton>}
      </DocumentRowItem>
      <DocumentRowItem>
        <TagSection textAlign="center" variant="caption" color={theme.palette.primary.main}>
          {accounting.type_id === 2 ? "اتوماتیک" : "دستی"}
        </TagSection>
        <PriceComponent price={`${formatPrice(accounting.amount)}`} color={theme.palette.disabled.main} />
      </DocumentRowItem>
    </DocumentContainer>
  );
};
